module.exports = __webpack_public_path__ + "img/lp-phone.ddb610f0.svg";